import mixpanel from 'mixpanel-browser';

const MIXPANEL_KEY = process.env.REACT_APP_MIXPANEL_KEY;

if (MIXPANEL_KEY) {
  mixpanel.init(MIXPANEL_KEY, {
    track_pageview: false,
    loaded: (mp) => {
      mp.register({
        'App Name':    'The BloxScale',
        'App Version': process.env.REACT_APP_VERSION ?? '0.1.0',
      });
    },
  });
}

export const identify = (
  email: string,
  firstName: string,
  lastName: string,
  company: string
) => {
  if (!MIXPANEL_KEY) return;
  mixpanel.identify(email);
  mixpanel.people.set({ $email: email, $name: `${firstName} ${lastName}`, 'Company Name': company });
};

export const track = (event: string, props?: Record<string, unknown>) => {
  if (!MIXPANEL_KEY) return;
  mixpanel.track(`BloxScale - ${event}`, props);
};

export const resetAnalytics = () => {
  if (!MIXPANEL_KEY) return;
  mixpanel.reset();
};
